import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';

interface PageComponentSignature {
  Args: {
    transparent?: boolean;
    fill?: boolean;
    scroll?: boolean;
    /**
     * Adapt for phones: flat (no shadow/radius) and half padding below the `sm` breakpoint.
     */
    responsive?: boolean;
  };
  Element: HTMLDivElement;
  Blocks: {
    default: [];
  };
}

export default <template>
  <div
    class="ui__page
      {{if @transparent 'ui__page--transparent'}}
      {{if (eq @fill false) 'ui__page--nofill'}}
      {{if (eq @scroll false) 'ui__page--noscroll'}}
      {{if @responsive 'ui__page--responsive'}}
      "
    ...attributes
  >
    {{yield}}
  </div>
</template> satisfies TOC<PageComponentSignature>;
